<script lang="ts" setup>
import AUApi from "@/api";
import { ref, onMounted, reactive } from "vue";
import { begriffBezeichnung } from "@/local";
const emit = defineEmits<{
  changeGroup: [data?:  boolean ];
}>();
const props = defineProps<{
  groupAic?: string;
  checked?: boolean;
  aicBegriff?: any;
}>();

let closeOnContentClick: boolean = true;

function setUserPara() {
  const varUbergabe: VarUebergabe[] = [];
  varUbergabe.push({
    aic: props.groupAic ? parseInt(props.groupAic.toString(), 10) : undefined,
    pGruppiert: props.checked,
  });
  AUApi.Current.setPersParameter(varUbergabe);
}
function deleteUserPara() {
  AUApi.Current.deletePersParameter(props.aicBegriff);
  const group = true;
  emit("changeGroup", group);
}
</script>
<template>
  <v-menu
    transition="slide-y-transition"
    location="bottom"
    offset-y
    :close-on-content-click="closeOnContentClick"
  >
    <template v-slot:activator="{ props }">
      <v-btn icon="mdi-dots-vertical" variant="text" v-bind="props"> </v-btn>
    </template>
    <v-menu offset-x open-on-hover>
      <template v-slot:activator="{ props }">
        <v-list v-bind="props">
          <v-list-item>
            <v-tooltip location="bottom" text="pers. Parameter speichern">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text"
                  color="green"
                  @click.stop="setUserPara()"
                  prepend-icon="mdi-cog-box"
                  :text="begriffBezeichnung('Speichern')"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-list-item>
          <v-list-item class="pt-0">
            <v-tooltip location="bottom" text="pers. Parameter löschen">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="text"
                  color="red"
                  @click.stop="deleteUserPara()"
                  prepend-icon="mdi-cog-box"
                  :text="begriffBezeichnung('Loeschen')"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </template>
    </v-menu>
  </v-menu>
</template>

<style scoped>
.v-list-item {
  padding: 0;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: 64px;
  padding: 0 5px;
}
</style>
